<template>
  <div id="app">
    <Header />
    <router-view />

    <footer class="foot">
      <p>
        <a
          href="http://www.mx1688.com.cn/"
          target="_blank"
        >首頁</a> |
        <a
          href="/web/#/about"
          target="_blank"
        >關於我們</a> |
<!--        <a href="/mobile" target="_blank">移動官網</a> | -->
        <a
          href="/web/#/privacy"
          target="_blank"
        >隱私條款</a> | <a
          href="/web/#/agreement"
          target="_blank"
        >使用條款</a>
      </p>
      <p>Copyright©2005~2020 美緣婚戀</p>
    </footer>
  </div>
</template>

<script>
import utils from "@/base/utils";
export default {
  name: "App",
  created() {
    this.$globalData.liveId = utils.getQueryString("liveId") || "";
  }
};
</script>

<style lang="scss">
@import "./styles/base.scss";
@import "./styles/reset.scss";
#app {
  background-color: #fff;
  line-height: px2rem(50px);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  // margin-top: 60px;
}
.head {
  img {
    margin-top: px2rem(100px);
    width: px2rem(100px);
    height: px2rem(100px);
  }
  .title {
    font-weight: 600;
    font-size: px2rem(36px);
  }
  .subtitle {
    font-weight: 500;
    font-size: px2rem(26px);
  }
  color: #ffffff;
  /*background: url("./logo.png");*/
  background-size: 100%;
  background-repeat: no-repeat;
  height: px2rem(340px);
}
.foot {
  a {
    color: #979797 !important;
  }
  padding-top: px2rem(20px);
  color: #979797;
  font-size: px2rem(24px);
  font-family: PingFang SC;
  font-weight: 400;
  margin-top: px2rem(100px);
  background-color: #333333;
  .bottom-pic {
    margin-top: px2rem(14px);
    margin-bottom: px2rem(24px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue